import axios from 'axios';

const appURL =
  process.env.NODE_ENV === 'production' || true ? 'https://capeladoalto.cidadeinteligente.app.br' : 'http://localhost:8000';

const axios_instance = axios.create({
  baseURL: `${appURL}/api/`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

axios_instance.interceptors.request.use(
  configuracao => {
    const token = localStorage.getItem('token');
    if (token) {
      configuracao.headers['Authorization'] = `Bearer ${token}`;
    }
    return configuracao;
  },
  error => {
    return Promise.reject(error);
  }
);

export const config = {
  appURL,
};

export default axios_instance;
